import { BYO_SLIP_ADD_SELECTION_TO_PROCESSING_QUEUE, BYO_SLIP_ADD_SELECTION_TO_STORE, BYO_SLIP_REMOVE_SELECTION_FROM_PROCESSING_QUEUE, BYO_SLIP_REMOVE_SELECTION_FROM_STORE, BYO_SLIP_ADD_PRICE_TO_STORE, BYO_SLIP_SELECTION_INCOMPATIBLE_ERROR, BYO_SLIP_REMOVE_PRICE_FROM_STORE, BYO_ODDS_FORMAT, BYO_SLIP_CLEAR_ALL, BYO_SLIP_EXPANDED, BYO_ERRORS_CLEAN_ALL, BYO_PROCESSING_TO_BETSLIP, BYO_ADD_TO_BETSLIP_ERROR, BYO_SET_EDIT_ID, } from '../constants';
import config from '../../config';
const initialState = {
    selections: {},
    processingSelections: [],
    prices: null,
    byoMarketId: null,
    error: null,
    oddsFormat: '',
    slipExpanded: false,
    addingToBetslip: false,
    addToBetslipError: null,
    maxSelectionsReached: false,
    editId: null,
};
//eslint-disable-next-line complexity
const slipReducer = (state = initialState, action = { type: '', payload: '' }) => {
    if (!action) {
        return state;
    }
    if (action.type === BYO_SLIP_EXPANDED) {
        return Object.assign(Object.assign({}, state), { slipExpanded: action.payload });
    }
    if (action.type === BYO_SLIP_ADD_SELECTION_TO_PROCESSING_QUEUE) {
        return Object.assign(Object.assign({}, state), { processingSelections: state.processingSelections
                .concat(action.payload) });
    }
    if (action.type === BYO_SLIP_ADD_SELECTION_TO_STORE) {
        if ((Object.keys(state.selections).length + 1) === config.maximumSelections) {
            return Object.assign(Object.assign({}, state), { maxSelectionsReached: true, selections: Object.assign(Object.assign({}, state.selections), { [action.payload.id]: action.payload }) });
        }
        return Object.assign(Object.assign({}, state), { selections: Object.assign(Object.assign({}, state.selections), { [action.payload.id]: action.payload }) });
    }
    if (action.type === BYO_PROCESSING_TO_BETSLIP) {
        return Object.assign(Object.assign({}, state), { addingToBetslip: action.payload, slipExpanded: action.payload });
    }
    if (action.type === BYO_SLIP_REMOVE_SELECTION_FROM_PROCESSING_QUEUE) {
        return Object.assign(Object.assign({}, state), { processingSelections: state.processingSelections
                .filter((sel) => sel.id !== action.payload.id) });
    }
    if (action.type === BYO_SLIP_REMOVE_SELECTION_FROM_STORE) {
        if (state.selections[action.payload.id]) {
            const newState = Object.assign(Object.assign({}, state), { maxSelectionsReached: false, selections: Object.assign({}, state.selections) });
            delete newState.selections[action.payload.id];
            return newState;
        }
        return state;
    }
    if (action.type === BYO_SLIP_ADD_PRICE_TO_STORE) {
        return Object.assign(Object.assign({}, state), { prices: action.payload && action.payload.price, byoMarketId: action.payload && action.payload.byoMarketId, error: null });
    }
    if (action.type === BYO_SLIP_REMOVE_PRICE_FROM_STORE) {
        return Object.assign(Object.assign({}, state), { prices: null, error: null });
    }
    if (action.type === BYO_SLIP_SELECTION_INCOMPATIBLE_ERROR) {
        return Object.assign(Object.assign({}, state), { error: action.payload });
    }
    if (action.type === BYO_ERRORS_CLEAN_ALL) {
        return Object.assign(Object.assign({}, state), { error: null, addToBetslipError: null });
    }
    if (action.type === BYO_ODDS_FORMAT) {
        return Object.assign(Object.assign({}, state), { oddsFormat: action.payload });
    }
    if (action.type === BYO_ADD_TO_BETSLIP_ERROR) {
        return Object.assign(Object.assign({}, state), { addToBetslipError: action.payload, addingToBetslip: false });
    }
    if (action.type === BYO_SET_EDIT_ID) {
        return Object.assign(Object.assign({}, state), { editId: action.payload });
    }
    if (action.type === BYO_SLIP_CLEAR_ALL) {
        return Object.assign(Object.assign({}, initialState), { oddsFormat: state.oddsFormat });
    }
    return state;
};
export default slipReducer;
